module.exports = __webpack_public_path__ + "img/404.83225226.png";